import { Page } from '@roc/feature-app-core';
import { RequestAppraisalReconsiderationModal } from '@roc/feature-appraisals';
import { Route } from 'react-router';

const LOANS_HOME_BASE_PATH = 'loans';
const LOAN_BASE_PATH = ':loanId';

export const getRequestAppraisalReconsiderationRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    loans: (loanId?: string) => ({
      path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}`,
      url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}`,
      children: {
        requestAppraisalReconsideration: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/request-appraisal-reconsideration`,
          url: `${basePath}/${LOANS_HOME_BASE_PATH}/${loanId}/request-appraisal-reconsideration`,
          documentTitle: `${loanId} - Request Appraisal Reconsideration`,
        },
      },
    }),
  };
};

export const getRequestAppraisalReconsiderationRoutes = (
  basePath: string,
  baseUrl: string,
  loanId: any,
  propertyId: any
) => {
  const config = getRequestAppraisalReconsiderationRoutesConfig(basePath, baseUrl);
  return {
    requestAppraisalReconsideration: (
      <Route exact path={config.loans().children.requestAppraisalReconsideration.path}>
        <Page routeDefinition={config.loans().children.requestAppraisalReconsideration}>
          <RequestAppraisalReconsiderationModal />
        </Page>
      </Route>
    ),
  };
};
